module.exports = __webpack_public_path__ + "static/img/service_introduce_JP01_zh_h5.0dec75c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_JP01_zh_h5.png
// module id = cB+x
// module chunks = 34